import { AuditTrailAssetType } from 'app/modules/auditService/types';

const BASE = ['audit-service'];

export const AUDIT_LIST_QUERY_KEYS = {
  list: (assetType: AuditTrailAssetType, assetId: string) =>
    [...BASE, assetType, assetId] as const,
};
